  var filters = [];
  var _data = [];
  var _data2 = [];
  var players = [];
  var players_collections = [];


	
	function doTopSearch(q){
      
      var handle = players_collections[q];
      window.open('/collections/'+handle, '_self');
      
	}

  
  function buildTopSearchMenu(){
    
    players.sort();
    
    var $select = $('#top-search-select');
    var $select2 = $('#top-search-select-mobile');
    
    $select.append($('<option>', {text: 'Search Player Name', value: ''}));
    $select2.append($('<option>', {text: 'Search Player Name', value: ''}));
    
    for(i in players){
      $select.append($('<option>', {text: players[i], value: players[i]}));
      $select2.append($('<option>', {text: players[i], value: players[i]}));
    }
    
    
    $select.dropdown({allowAdditions: false, placeholder: 'Player Name', action : function(a){ doTopSearch(a); }});
    $select2.dropdown({allowAdditions: false, placeholder: 'Player Name', action : function(a){ doTopSearch(a); }});
    
    $('.ui.search.dropdown').prepend('<span class="timber-icon timber-icon-search" aria-hidden="true">');
    
    $select.show();
    
  
  }
  
  function filterData(x){
    
    var a = x.split('/');
    
    if(_data[a[0]] == null) _data[a[0]] = [];
    if(_data[a[0]][a[1]] == null) _data[a[0]][a[1]] = [];
    
    
    _data[a[0]][a[1]].push(a[2]);
    players.push(a[2]);
    
    players_collections[a[2]] = [a[2], a[1], a[0]].join('-').replace(/\W+/g, "-").toLowerCase();
    
  }
  
  function filterData2(x){
    
    var a = x.split('/');
    
    if(_data2[a[0]] == null) _data2[a[0]] = [];
    if(_data2[a[0]][a[1]] == null) _data2[a[0]][a[1]] = [];
    
    
    _data2[a[0]][a[1]].push(a[2]);
    
  }


$(document).ready(
  function(){
  	buildTopSearchMenu();
  }
);